// extracted by mini-css-extract-plugin
export default {"root":"SectionedForm_root__aGzlC"};